import apiService from '../apiService';

// 取得關聯列表
export const getOptionRelations = async (params = {}) => {
    try {
        const response = await apiService.GET('api/admin/option_relations', params);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 新增關聯資料
export const createOptionRelation = async (data) => {
    try {
        const response = await apiService.POST('api/admin/option_relations', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 更新關聯資料
export const updateOptionRelation = async (id, data) => {
    try {
        const response = await apiService.PUT(`api/admin/option_relations/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 刪除關聯資料
export const deleteOptionRelation = async (id) => {
    try {
        const response = await apiService.DELETE(`api/admin/option_relations/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
